// extracted by mini-css-extract-plugin
export var measureBox = "_50-0";